var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#icn-shield_svg__clip0)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.117 6.48L16.09.07a.597.597 0 00-.569.004L3.827 6.482a.599.599 0 00-.31.526v8.371a17.333 17.333 0 0010.388 15.864l1.623.707a.598.598 0 00.477 0l1.829-.79a17.3 17.3 0 0010.6-15.947V7.008a.6.6 0 00-.317-.529zm-.88 8.733a16.105 16.105 0 01-9.872 14.846l-.004.002-1.593.688-1.384-.604a16.134 16.134 0 01-9.67-14.766V7.362L15.812 1.28l11.424 6.088v7.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.395 14.99a.599.599 0 00-.91.778l3.162 3.704a.599.599 0 00.833.076l7.366-5.993a.599.599 0 10-.755-.929l-6.913 5.624-2.783-3.26z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icn-shield_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgIcnShield;